export default __webpack_public_path__ + "static/media/avatar-2.6cc481d4.jpg";